import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';

export class RunReportModal extends React.Component {

  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    report: this.props.report,
    date: ''
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  saveChanges = async () => {
    this.props.closeModal()
    toast.warning('Generating Report...please wait', {autoClose: false})
    let requestParams = {
      'report': this.state.report,
      'date': this.state.date
    }
    axios.post('/reports/run', requestParams)
          .then(data => {
            toast.dismiss()
            toast.success('Report sent via email')
          })
          .catch(err => {
            toast.dismiss()
            console.error(err); 
            Rollbar.error(err)
            toast.error("Error: Could not run report!");
          })
  }

  render() {
    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Run Report</h5>
            <button type="button" className="close" onClick={this.props.closeModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label>Delivery Date:</label>
              <input type="date" className="form-control" name="date" value={this.state.date} onChange={this.handleChange} />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={this.props.closeModal}>Close</button>
            <button type="button" onClick={this.saveChanges} className="btn btn-primary" disabled={!this.state.date}>Run</button>
          </div>
        </div>
      </div>
    );
  }
}